<div class="edit-button-group">
  <input
    class="input-text"
    id="edit_ct_{{ id }}"
    (keyup.enter)="updateQuota($event)"
    (keydown.Tab)="updateQuota($event); (false)"
    [(ngModel)]="value"
    type="text"
    tabindex="0"
    onfocus="this.select()"
  />
  <div class="fa fa-check" (click)="updateQuota($event)"></div>
  <div class="fa fa-times" (click)="cancelQuota()"></div>
</div>
